<template>
  <div style="height: calc(100vh - 135px);overflow: auto;padding:8px">
    <!-- <div class="page_header" style="">
      <span class="page_title" style="flex: 1">{{$t('PersonalizedConfig.个性化配置')}}</span>
    </div> -->
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
       
        <el-tab-pane v-if="getIsConfig('gasConsumeUinit')" :label="$t('PersonalizedConfig.气耗单位配置')" name="gasConsumeUinit">
          <gasConsumeUinit />
        </el-tab-pane>
         <el-tab-pane v-if="getIsConfig('mobileAndSMSConfig')" :label="$t('PersonalizedConfig.一键报警配置')" name="mobileAndSMSConfig">
          <mobileAndSMSConfig />
        </el-tab-pane>
        <el-tab-pane v-if="getIsConfig('mapConfig')" :label="$t('PersonalizedConfig.地图配置')" name="mapConfig">
          <mapConfig />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import mobileAndSMSConfig from '@/views/setting/personalizedConfig/mobileAndSMSConfig.vue'
import mapConfig from '@/views/setting/personalizedConfig/mapConfig.vue'
import gasConsumeUinit from '@/views/setting/personalizedConfig/gasConsumeUinit.vue'
import {
  getMenus

} from "@/utils/auth";
export default {
  name: 'personalizedConfig',
  components: { mobileAndSMSConfig, mapConfig, gasConsumeUinit },
  data() {
    return {
      activeName: "gasConsumeUinit",
    };
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
  },
  beforeMount() {
    var menu_json = getMenus();
    // console.log(menu_json)
    this.menu_json = JSON.parse(menu_json);
  },
  methods: {
    handleClick() { },
    getIsConfig(configName) {
      var isConfig = false;
      //从菜单里面判断有没有这个配置 RegisterName 
      isConfig = this.menu_json.some(item => item.RegisterName === configName);//
      if (isConfig) {
        this.activeName = configName;
      }
      return isConfig;
    }
  },
};
</script>
<style lang="scss" scoped></style>